import { SuperAdminTracePage } from "../../operator/console/super-admin-trace";

export default function ConsoleSuperAdminTrace() {
  return <SuperAdminTracePage />;
}
